import './HourBlocks.scss';

import { useSelector } from 'react-redux';
import classNames from 'classnames';

import Dropdown from 'atoms/dropdown';
import Input from 'atoms/input';
import { closeTimeHours } from 'util';
import { hoursOptions } from 'util/constants';

export function HourBlocks({ setHours, hours, hideTitle }) {
  const dowOptions = useSelector((state) => state.main.calendar.dayOfWeek);

  return (
    <div className="hours-container">
      {!hideTitle && <h1>When are you open?</h1>}
      {dowOptions.map((el, i) => (
        <div className="flex-row mb-15" key={el.value}>
          <Input
            className="days"
            label={i === 0 && 'Day'}
            readOnly
            value={el.value}
          />
          <Dropdown
            id={i === 0 && 'Hours'}
            className="hours"
            label={i === 0 && 'Hours'}
            placeholder="Closed"
            items={hoursOptions}
            generateKey
            onClick={(item) => {
              setHours({
                ...hours,
                [el.value]: {
                  ...hours[el.value],
                  timeStart: item,
                  dowId: el.id,
                },
              });
            }}
            value={
              hours[el.value].timeEnd?.value !== 'Closed'
                ? hours[el.value].timeStart?.value
                : '-'
            }
          />
          <Dropdown
            className={classNames(i === 0 && 'hidden-label', 'hours')}
            placeholder="–"
            items={closeTimeHours(hours[el.value].timeStart)}
            generateKey
            onClick={(item) =>
              setHours({
                ...hours,
                [el.value]: {
                  ...hours[el.value],
                  timeEnd: item,
                  dowId: el.id,
                },
              })
            }
            value={
              hours[el.value].timeStart?.value !== 'Closed'
                ? hours[el.value].timeEnd?.value
                : '-'
            }
          />
        </div>
      ))}
    </div>
  );
}
